import React, { useState, useContext, useEffect, useMemo } from 'react';
import {
  CompositeView,
  CrudContext,
  GridView,
  SimpleView,
  usePromise,
  FilterWidget,
  FormRangePicker,
  MasterDetailForm,
  Button,
} from '@digital/ui';
import { Collapse } from 'antd';
import { getAllContabilidadeGeral, ContabilidadeGeralModel } from '@app/api/ContabilidadeGeral';
// importar abas
import PendentesBaixadosRecusados from './PendentesBaixadosRecusados';
import IntegradosCancelados from './IntegradosCancelados';

import { hasPermission } from '@app/helpers/permissions';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import { date } from 'yup';
import { SearchButton } from '@app/components/FormButtons';

const ContabilidadeGeral = () => {
  const { selectedItem } = useContext(CrudContext);
  const { Panel } = Collapse;

  const [update, setUpdate] = useState(true);
  const [periodoInicio, setPeriodoInicio] = useState(null);
  const [periodoFim, setPeriodoFim] = useState(null);

  const onUpdate = () => {
    setUpdate(!update);
  };

  const [contabilidadeGeralPromise] = usePromise(
    async () => {
      return await getAllContabilidadeGeral({ periodoInicio: periodoInicio, periodoFim: periodoFim });
    },
    [update],
    {} as ContabilidadeGeralModel,
  );

  return (
    <SimpleView>
      <CompositeView>
        <GridView icon="ui-in_progress" noform id="pendentesBaixadosRecusados" title="Pendentes/Baixados/Recusados">
          <PendentesBaixadosRecusados pendentesBaixadosRecusados={contabilidadeGeralPromise} updatePage={onUpdate} />
        </GridView>

        <GridView icon="ui-offline_pin" noform id="integradosCancelados" title="Integrados/Cancelados">
          <FilterWidget
            active={[]}
            actions={[
              <Button type="primary" key="filterBtn" onClick={() => onUpdate()}>
                Pesquisar
              </Button>,
            ]}>
            <MasterDetailForm>
              <FormRangePicker
                value={[periodoInicio, periodoFim]}
                startName="dataInicio"
                endName="dataFinal"
                format={dateFormat}
                label="Período"
                span={4}
                onChange={dates => {
                  setPeriodoInicio(dates[0]);
                  setPeriodoFim(dates[1]);
                }}
              />
            </MasterDetailForm>
          </FilterWidget>

          <IntegradosCancelados integradosCancelados={contabilidadeGeralPromise} />
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};

export default ContabilidadeGeral;
